import clsx from 'clsx';
import { Field } from 'formik';
import React from 'react';
import { FC } from 'react';
import styles from './FormRadioButton.module.scss';

interface Props {
    id?: string;
    name: string;
    value?: any;
    label?: string;
    className?: string;
    size?: 'medium' | 'large';
}

export const FormRadioButton: FC<Props> = ({
    id,
    name,
    value,
    label,
    className,
    size = 'medium',
    children,
}) => {
    return (
        <label
            className={clsx(
                size === 'medium' && styles.labelMedium,
                size === 'large' && styles.labelLarge,
                className
            )}
        >
            <Field
                className={styles.input}
                type="radio"
                name={name}
                id={id}
                value={value}
            />
            <span
                className={clsx(
                    styles.label,
                    size === 'medium' && styles.medium,
                    size === 'large' && styles.large
                )}
            >
                {label || children}
            </span>
        </label>
    );
};
